import { combineReducers } from 'redux'

import arquivosContrato from './arquivosContrato'

export default combineReducers({ arquivosContrato })
